import React from 'react'

import { Box, Flex, Icon, Link } from '@driftt/dds'
import { faArrowPointer } from '@driftt/dds.icons/light/faArrowPointer';
import { faGlobe } from '@driftt/dds.icons/light/faGlobe';
import { faMagnifyingGlass } from '@driftt/dds.icons/light/faMagnifyingGlass';

import { pluralize } from 'utils/formatStrings';


interface SearchContentProps {
  searchQuery: string
  pages: { url?: string; title?: string }[]
  trackAction: (action: string, additionalData?: any) => void
}

export const SearchContent = ({ searchQuery, pages, trackAction }: SearchContentProps) => {

  return (
    <Box css={{ paddingTop: '16px' }}>
      <Flex alignItems='center' css={{ paddingBottom: '4px' }}>
        <Icon size="medium" icon={faMagnifyingGlass} color="blue9" />
        <Link
          href={'/reports/siteconcierge/search'}
          onClick={() => trackAction('Buyer search query click', { searchQuery })}
          target="_blank"
          truncate
          css={{ textDecoration: 'none', color: '$blue9' }}>
          {`"${searchQuery}"`}
        </Link>
      </Flex>
      {pages.length > 0 && 
        <Flex alignItems='center'>
          <Icon size="large" icon={faArrowPointer} />
          {`Clicked on ${pages.length} ${pluralize('source', pages.length)}`}
        </Flex>
      }
      {pages.map((page, index) => (
        <Flex key={index} css={{ paddingLeft: '16px', marginTop: '4px' }} alignItems='center'>
          <Icon size="medium" icon={faGlobe} color="blue9" />
          <Link
            href={page.url}
            onClick={() => trackAction('Buyer search results click', { url: page.url })}
            target="_blank"
            truncate
            css={{ color: '$blue9', textDecoration: 'none' }}>
            {page.title}
          </Link>
        </Flex>
      ))}
    </Box>
  )
}
